import { auth, db } from '../firebase';
import {
    GoogleAuthProvider,
    signInWithPopup,
    signOut,
    onAuthStateChanged,
    getIdToken
} from 'firebase/auth';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

const googleProvider = new GoogleAuthProvider();

/**
 * Sync user profile to Firestore
 */
const syncUserProfile = async (user) => {
    if (!user) return;

    const userRef = doc(db, 'users', user.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
        // New user - create profile with default balance
        await setDoc(userRef, {
            uid: user.uid,
            email: user.email,
            displayName: user.displayName,
            photoURL: user.photoURL,
            virtualBalance: 1000, // Default Paper Trading Balance
            createdAt: serverTimestamp(),
            lastLogin: serverTimestamp()
        });
    } else {
        // Existing user - update last login
        await setDoc(userRef, {
            lastLogin: serverTimestamp(),
            email: user.email, // Sync in case changed
            displayName: user.displayName,
            photoURL: user.photoURL
        }, { merge: true });
    }
};

/**
 * Sign in with Google Popup
 */
export const signInWithGoogle = async () => {
    try {
        const result = await signInWithPopup(auth, googleProvider);
        await syncUserProfile(result.user);
        return result.user;
    } catch (error) {
        console.error("Google Sign-In Error:", error);
        throw error;
    }
};

/**
 * Logout
 */
export const logout = async () => {
    try {
        await signOut(auth);
        localStorage.removeItem('token');
        localStorage.removeItem('userAddress');
    } catch (error) {
        console.error("Logout Error:", error);
        throw error;
    }
};

/**
 * Get current user
 */
export const getCurrentUser = () => auth.currentUser;

/**
 * Get Firebase ID Token
 */
export const getAuthToken = async () => {
    const user = auth.currentUser;
    if (user) {
        return await getIdToken(user);
    }
    return null;
};

/**
 * Listen to auth state changes
 */
export const subscribeToAuthChanges = (callback) => {
    return onAuthStateChanged(auth, async (user) => {
        if (user) {
            // Also sync on auto-login/page refresh path
            // detailed sync might be skipped here to avoid redundant writes if unnecessary,
            // but ensuring profile exists is good practice.
            // await syncUserProfile(user); 
        }
        callback(user);
    });
};

export default {
    signInWithGoogle,
    logout,
    getCurrentUser,
    getAuthToken,
    subscribeToAuthChanges,
    syncUserProfile // Export for use in other contexts if needed
};
